import Box from '@liquidweb-dev/undercurrent/Box';
import Skeleton from '@liquidweb-dev/undercurrent/Skeleton';
import TypographyOverflow from '@liquidweb-dev/undercurrent/TypographyOverflow';
import { useLeftHandLayout } from 'components/LeftHandLayout';

export const COLLAPSED_HEADER_HEIGHT = 72;

export interface CollapsedHeaderProps {
	actionsSlot?: React.ReactNode;
	attributesSlot?: React.ReactNode;
	isLoading?: boolean;
	show: boolean;
	title: string;
}

const CollapsedHeader = ({
	actionsSlot,
	attributesSlot,
	isLoading,
	show,
	title,
}: CollapsedHeaderProps) => {
	const { topInnerX, topSize, topOuterY } = useLeftHandLayout();

	return (
		<Box
			sx={{
				height: `${COLLAPSED_HEADER_HEIGHT}px`,
				display: 'flex',
				gap: 200,
				justifyContent: 'space-between',
				alignItems: 'center',
				visibility: show ? 'visible' : 'hidden',
				transition: 'ease-in-out 0.2s',
				opacity: show ? 1 : 0,
				top: `${topSize + topOuterY}px`,
				position: 'sticky',
				zIndex: (theme) => theme.zIndex.appBar - 1,
				paddingTop: 200,
				paddingX: `${topInnerX}px`,
				paddingBottom: 200,
				backgroundColor: (theme) => theme.vars.palette.uc.bg.main,
				borderBottomStyle: 'solid',
				borderBottomWidth: '1px',
				borderBottomColor: ({ vars }) => vars.palette.uc.border.weak,
				marginBottom: `-${COLLAPSED_HEADER_HEIGHT}px`,
			}}
		>
			<Box
				sx={{
					display: 'flex',
					alignItems: 'center',
					gap: 200,
					minWidth: 0,
					overflow: 'auto',
				}}
			>
				<TypographyOverflow
					variant="body-md"
					sx={{
						color: 'uc.text.main',
					}}
				>
					{isLoading ? (
						<Skeleton
							variant="rounded"
							width={200}
							sx={(theme) => ({
								height: theme.size.sm,
							})}
						/>
					) : (
						title
					)}
				</TypographyOverflow>

				{attributesSlot && (
					<Box sx={{ display: 'flex', gap: 100 }}>{attributesSlot}</Box>
				)}
			</Box>
			{actionsSlot && <Box sx={{ gridArea: 'actions' }}>{actionsSlot}</Box>}
		</Box>
	);
};

export default CollapsedHeader;
